import { Component } from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {SystemManagementService} from '../../services/system-management.service';
import {finalize} from 'rxjs/operators';
import {EntitlementsService} from '../../entitlements/entitlements.service';
import { WindowRef } from '../../shared/services/window/window.ref';

@Component({
  selector: 'ssg-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.less'],
})
export class LogoutComponent {

  constructor(private oauthService: OAuthService,
              private systemManagementService: SystemManagementService,
              private entitlementService: EntitlementsService,
              private windowRef: WindowRef) {
    this.systemManagementService.revokeAccessToken()
      .pipe(finalize(() => {
        this.oauthService.logOut();
        this.entitlementService.clearEntitlementData();
        if (this.windowRef.nativeWindow.parent) {
          window.parent.postMessage('COMPLETE', '*');
        }
      }))
      .subscribe();
  }
}
